const f = {
  inherit: "inherit",
  white: "#ffffff",
  black: "#000000",
  n1: "#fdfcfd",
  n2: "#f9f8f9",
  n3: "#f4f2f4",
  n4: "#eeedef",
  n5: "#e9e8ea",
  n6: "#e4e2e4",
  n7: "#dcdbdd",
  n8: "#c8c7cb",
  n9: "#908e96",
  n10: "#86848d",
  n11: "#6f6e77",
  n12: "#1a1523",
  p1: "#fcfbfe",
  p2: "#f8f5ff",
  p3: "#f4f0ff",
  p4: "#ede7fe",
  p5: "#e7defc",
  p6: "#d9cdf9",
  p7: "#c9b9f3",
  p8: "#af98ec",
  p9: "#744ed4",
  p10: "#6b48c7",
  p11: "#6346af",
  p12: "#20104d",
  r1: "#fffcfc",
  r2: "#fff8f8",
  r3: "#ffefef",
  r4: "#ffe5e5",
  r5: "#fdd8d8",
  r6: "#f9c6c6",
  r7: "#f3aeaf",
  r8: "#eb9091",
  r9: "#e5484d",
  r10: "#dc3d43",
  r11: "#cd2b31",
  r12: "#381316",
  g1: "#fbfefc",
  g2: "#f2fcf5",
  g3: "#e9f9ee",
  g4: "#ddf3e4",
  g5: "#ccebd7",
  g6: "#b4dfc4",
  g7: "#92ceac",
  g8: "#5bb98c",
  g9: "#30a46c",
  g10: "#299764",
  g11: "#18794e",
  g12: "#153226",
  y1: "#fefdfb",
  y2: "#fff9ed",
  y3: "#fff4d5",
  y4: "#ffecbc",
  y5: "#ffe3a2",
  y6: "#ffd386",
  y7: "#f3ba63",
  y8: "#ee9d2b",
  y9: "#ffb224",
  y10: "#ffa01c",
  y11: "#ad5700",
  y12: "#4e2009",
  lb100: "#d6f0ff",
  lb300: "#96d5f8",
  lb500: "#4fb5ee",
  lb700: "#0b75aa",
  g100: "#ebff5e",
  g500: "#8dc31a",
  red500: "#ff5377",
  orange500: "#ff9457",
  teal500: "#36e79b"
};
export {
  f as colors
};
//# sourceMappingURL=colors.js.map
